<div class="search-page p-6 text-(--body-text-color)">
    @if (vm$ | async; as vm) {

    @if (vm.query) {
    <h2 class="page-title" i18n>Search results for "{{ vm.query }}"</h2>
    }

    @if (vm.status === 'idle' && !vm.query) {
    <div class="text-sm text-gray-500" i18n>
        Enter a term in the toolbar search to get started.
    </div>
    }

    @if (vm.status === 'loading') {
    <div class="text-sm text-gray-500" i18n>
        Loading search results...
    </div>
    }

    @if (vm.status === 'error') {
    <div class="text-sm text-red-600" i18n>
        Something went wrong loading search results. Please try again.
    </div>
    }

    @if (vm.status === 'success') {
    <div class="results-container">

        <!-- Participants -->
        <section class="result-section">
            <div class="section-header">
                <mat-icon aria-hidden="true">person</mat-icon>
                <h3><span i18n>Participants</span> <span class="count">({{ vm.results.participantSearchResults.length
                        }})</span></h3>
            </div>

            @if (vm.results.participantSearchResults.length) {
            <div class="result-table participant-table">
                <div class="ghost-header">
                    <span i18n>Name</span>
                    <span i18n>Project</span>
                    <span i18n>Hogan ID #</span>
                    <span i18n>Unique ID #</span>
                    <span i18n>Email</span>
                </div>
                @for (p of vm.results.participantSearchResults; track p.participantId) {
                <div class="result-row" (click)="goToParticipant(p)">
                    <div class="cell">
                        <span class="value">{{ participantName(p) }}</span>
                        <span class="label" i18n>Name</span>
                    </div>
                    <div class="cell">
                        <span class="value">{{ p.projectName }}</span>
                        <span class="label" i18n>Project</span>
                    </div>
                    <div class="cell">
                        <span class="value">{{ p.participantId }}</span>
                        <span class="label" i18n>Hogan ID #</span>
                    </div>
                    <div class="cell">
                        <span class="value">{{ p.uniqueId }}</span>
                        <span class="label" i18n>Unique ID #</span>
                    </div>
                    <div class="cell">
                        <span class="value">{{ p.email }}</span>
                        <span class="label" i18n>Email</span>
                    </div>
                </div>
                }
            </div>
            } @else {
            <p class="empty" i18n>No participants found.</p>
            }
        </section>

        <!-- Projects -->
        <section class="result-section">
            <div class="section-header">
                <mat-icon aria-hidden="true">person</mat-icon>
                <h3><span i18n>Projects</span> <span class="count">({{ vm.results.projectSearchResults.length }})</span>
                </h3>
            </div>

            @if (vm.results.projectSearchResults.length) {
            <div class="result-table project-table">
                @for (p of vm.results.projectSearchResults; track p.projectId) {
                <div class="result-row" (click)="goToProject(p)">
                    <div class="cell">
                        <span class="value">{{ p.projectName }}</span>
                        <span class="label" i18n>Project</span>
                    </div>
                    <div class="cell">
                        <span class="value">{{ formatCreated(p.createdDate) }}</span>
                        <span class="label" i18n>Created Date</span>
                    </div>
                    <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
                </div>
                }
            </div>
            } @else {
            <p class="empty" i18n>No projects found.</p>
            }
        </section>

    </div>
    }
    }
</div>